import { memo, useState } from 'react';

import PropTypes from 'prop-types';

import { Box, ButtonBase, Portal } from '@mui/material';

import { avatarPlaceholderSRC } from '../../utils';

import Carousel from './Carousel';

const CarouselComponent = memo((props) => {
  const {
    images,
    isLoading,
    isSquare,
    isClickable = true,
    height: initialHeight = '20rem',
    width: initialWidth,
  } = props;

  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [hasBrokenImg, setHasBrokenImg] = useState(false);

  const disabled = hasBrokenImg || !isClickable;

  const toggleFullScreen = (event, selectedIndex) => {
    event.stopPropagation();
    setIsFullScreen(!isFullScreen);
    setSelectedIndex(selectedIndex);
  };

  let height = initialHeight;
  let width = initialWidth;
  if (isSquare && height) {
    width = height;
  }
  if (isSquare && width) {
    height = width;
  }
  if (!width) {
    width = 'auto';
  }

  return (
    <>
      {!isLoading && (
        <Box display="flex" flexWrap="wrap" gap="1rem">
          {images.map(({ caption, source }, i) => (
            <ButtonBase
              component={isClickable ? 'button' : 'div'}
              key={i}
              onClick={(e) => !disabled && toggleFullScreen(e, i)}
              sx={{ height, width }}
            >
              <img
                alt={caption}
                src={hasBrokenImg ? avatarPlaceholderSRC : source.thumbnail}
                style={{
                  borderRadius: 5,
                  height,
                  width,
                  objectFit: 'cover',
                }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = avatarPlaceholderSRC;
                  if (!hasBrokenImg) setHasBrokenImg(true);
                }}
              />
            </ButtonBase>
          ))}
        </Box>
      )}

      {!isLoading && (
        <Portal>
          <Carousel
            images={images}
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
            isFullScreen={isFullScreen}
            toggleFullScreen={toggleFullScreen}
            setIsFullScreen={setIsFullScreen}
          />
        </Portal>
      )}
    </>
  );
});

CarouselComponent.propTypes = {
  images: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool,
  height: PropTypes.string,
  width: PropTypes.string,
  isClickable: PropTypes.bool,
  isSquare: PropTypes.bool,
};

export default CarouselComponent;
